import { Transition }               from '@uirouter/core';

import { ApiService }          from '../../../app-lite/api/api.service';
import { CompanyService }      from '../../../app-lite/companies/company.service';
import { TillpaymentsService } from '../../../app-lite/tillpayments/tillpayments.service';

import { CustomerPaymentComponent } from './customer-payment.component';

export const CustomerPaymentStates: Array<any> = [
  {
    component : CustomerPaymentComponent,
    name      : 'app.customer-payment',
    params    : {
      customer_id: { squash: true, value: null },
      id         : { squash: true, value: null }
    },
    reloadOnSearch: false,
    url           : '/:customer_id/customer_payment/:id?invoice_id',
    resolve       : [
      { token: 'companyMessages', deps: [CompanyService],    resolveFn: (companyService: CompanyService)   => companyService.getDefaultMessages() },
      { token: 'integrations',    deps: [ApiService],        resolveFn: (apiService: ApiService)           => apiService.get('/company_integrations') },
      { token: 'pos_terminals',   deps: [ApiService],        resolveFn: (apiService: ApiService)           => apiService.get('/pos_terminals') },
      { token: 'customer',        deps: [Transition, ApiService], resolveFn: (transition: Transition, apiService: ApiService) =>
          transition.params().customer_id
            ? apiService.get('/customer', transition.params().customer_id)
            : '' },
      { token: 'payment',         deps: [Transition, ApiService], resolveFn: (transition: Transition, apiService: ApiService) =>
          transition.params().id
            ? apiService.get('/customer_payment', transition.params().id)
            : '' },
      { token: 'lostTerminalTransaction', deps: [CompanyService, 'payment', TillpaymentsService],
        resolveFn: (companyService: CompanyService, payment, tillpaymentsService: TillpaymentsService) =>
          companyService.hasIntegration('tillpayments-pos')
            ? tillpaymentsService.doesLostTerminalPaymentExist(payment)
            : false }
    ]
  }
];
